module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.e18bbf61.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap/fonts/glyphicons-halflings-regular.ttf
// module id = 2393
// module chunks = 50